export const estimateKeys = {
  all: ["estimates"] as const,
  lists: () => [...estimateKeys.all, "list"] as const,
  list: (filters: Record<string, unknown>) => [...estimateKeys.lists(), filters] as const,
  totals: (filters: Record<string, unknown>) => [...estimateKeys.all, "totals", filters] as const,
  details: () => [...estimateKeys.all, "detail"] as const,
  detail: (id: string) => [...estimateKeys.details(), id] as const,
};
